import loadable from "src/utils/loadable";
//@ts-ignore
// import menu from "./test";
const menu = loadable(() => import("./menu"));

export default menu;
